import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { OrderDataHolder, OrderStatus } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrdersInfrastructure {
  private readonly endpoint = environment.apihost + environment.ordersUrl;

  constructor(
    private _http: HttpClient,
    private _authState: AuthStateFacade,
  ) {}

  public getOrders(status: OrderStatus, page = 0, size = 10): Observable<OrderDataHolder> {
    const customerId = this._authState.customerId;
    return this._http.get<OrderDataHolder>(this.endpoint, {
      params: {
        customerId,
        status,
        page,
        size,
      },
    });
  }
}
